import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  toolbarRoot: {
    width: "100%",
    borderTop: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[0],
    paddingBottom: "env(safe-area-inset-bottom)",
    height: "auto",
    background: "white"
  },
  action: {
    "& span": {
      fontSize: theme.typography.body1.fontSize,
      "& .Mui-selected": {
        fontSize: theme.typography.body1.fontSize
      }
    },
    "& svg": {
      fontSize: theme.typography.h5.fontSize
    }
  }
}));
